/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* DEPOSIT */
export const SET_DEPOSIT_LIST = "SET_DEPOSIT_LIST";
export const ADD_NEW_DEPOSIT = "ADD_NEW_DEPOSIT";
export const UPDATE_DEPOSIT = "UPDATE_DEPOSIT";
export const DELETE_DEPOSIT = "DELETE_DEPOSIT";
export const OPEN_DEPOSIT_FORM = "OPEN_DEPOSIT_FORM";
export const CLOSE_DEPOSIT_FORM = "CLOSE_DEPOSIT_FORM";
export const EDIT_SELECTED_DEPOSIT = "EDIT_SELECTED_DEPOSIT";
export const DEPOSIT_FORM_TOOGLE_LOADING = "DEPOSIT_FORM_TOOGLE_LOADING";
/* <---- DEPOSIT ----> */

/* SPENT */
export const SET_SPENT_LIST = "SET_SPENT_LIST";
export const ADD_NEW_SPENT = "ADD_NEW_SPENT";
export const UPDATE_SPENT = "UPDATE_SPENT";
export const DELETE_SPENT = "DELETE_SPENT";
export const OPEN_SPENT_FORM = "OPEN_SPENT_FORM";
export const CLOSE_SPENT_FORM = "CLOSE_SPENT_FORM";
export const EDIT_SELECTED_SPENT = "EDIT_SELECTED_SPENT";
export const SPENT_FORM_TOOGLE_LOADING = "SPENT_FORM_TOOGLE_LOADING";
/* <---- SPENT ----> */

/* ACCOUNT */
export const SET_ACCOUNT_LIST = "SET_ACCOUNT_LIST";
export const ADD_NEW_ACCOUNT = "ADD_NEW_ACCOUNT";
export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const OPEN_ACCOUNT_FORM = "OPEN_ACCOUNT_FORM";
export const CLOSE_ACCOUNT_FORM = "CLOSE_ACCOUNT_FORM";
export const EDIT_SELECTED_ACCOUNT = "EDIT_SELECTED_ACCOUNT";
export const ACCOUNT_FORM_TOOGLE_LOADING = "ACCOUNT_FORM_TOOGLE_LOADING";
/* <---- ACCOUNT ----> */

/* SPENTTYPE */
export const SET_SPENTTYPE_LIST = "SET_SPENTTYPE_LIST";
export const ADD_NEW_SPENTTYPE = "ADD_NEW_SPENTTYPE";
export const UPDATE_SPENTTYPE = "UPDATE_SPENTTYPE";
export const DELETE_SPENTTYPE = "DELETE_SPENTTYPE";
export const OPEN_SPENTTYPE_FORM = "OPEN_SPENTTYPE_FORM";
export const CLOSE_SPENTTYPE_FORM = "CLOSE_SPENTTYPE_FORM";
export const EDIT_SELECTED_SPENTTYPE = "EDIT_SELECTED_SPENTTYPE";
export const SPENTTYPE_FORM_TOOGLE_LOADING = "SPENTTYPE_FORM_TOOGLE_LOADING";
/* <---- SPENTTYPE ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */
